 
    
    import CadastroInline from '@/components/aplicacao/CadastroInline.vue';    
    import Multiselect from '@vueform/multiselect'
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
    import ListaCampoForm from '@/components/aplicacao/ListaCampoForm.vue'; 
    import EnderecoService  from '@/service/v10/sigap/EnderecoService'; 
    import { Endereco } from "./Endereco"; 
    import { Options, Vue  } from "vue-class-component";  
	import $ from "jquery"  
    import {  Prop  , Watch } from 'vue-property-decorator';   
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    import axios from "axios";
    import { User } from "@/store/modules/AuthModule";
	  
    @Options({
        name: "EnderecoCadastro",
        components: {  CadastroInline  , Multiselect, ListaCampoForm, BotaoSalvar  },  
        emits: [  'endereco-militar-alterado'],  
    }) 
    export default class EnderecoCadastro extends Vue {
        
        @Prop( ) readonly modal_cadastro!: any 
        @Prop( ) readonly currentUser!: User 

        public modal = '';
        public editando = false;
        public processando = false; 
        public service:any = null ;  
        public endereco_correios:any = null ;  
        public formulario: any  = { } ;   
        public campos: Array<any> = [ ];
 
        created() { 
            this.service = new EnderecoService();  
            this.campos =  Endereco.campos();  
            this.formulario.cep ='29'; 
        }
     
        get hasPermissao(   ): boolean {
            return true;
        }
 
        public editar(){ 
            if( this.hasPermissao ){
                this.editando = !this.editando ;  
            }
            else {
                this.editando = false ;
            } 
        }
 
        public getdados(){  
            this.formulario.usuarioId  = this.currentUser.id; 
            let dados = JSON.parse(JSON.stringify(this.formulario));  
            return dados;
        }
 
        public sucesso(){  
            this.$emit("endereco-militar-alterado", null);     
            $("[data-bs-dismiss='modal']").trigger({ type: "click" });
        } 
 
        public salvar(){
            if( this.processando  ||  !this.hasPermissao ){
                return;
            }
            this.processando = true ;  
            let dados = this.getdados() ;  
            setTimeout(() => {  
                this.service.cadastrarMy( dados )
                .then(response => { 
                    SiteUtils.toastSucesso('Cadastrado com sucesso! ' ,  response.message  );
                    this.sucesso();  
                    this.formulario = {};
                    this.formulario.cep ='29';
                    this.processando = false ; 
                    this.editando = false ;
                }) 
                .catch(error => {
                    this.processando = false ;
                    SiteUtils.toastErro('Error! ' ,  error.data.message  );
                });  
            }, 100); 
        } 

        buscarCEP( ) { 
            if(this.formulario.cep.length == 8){ 
                axios.get( "https://viacep.com.br/ws/" + this.formulario.cep + "/json/" , {  }  )
                .then(response => {    
                    this.endereco_correios =   response.data;
                    this.formulario.logradouro =  this.endereco_correios.logradouro; 
                    this.formulario.bairro =  this.endereco_correios.bairro; 
                    this.formulario.cidade =  this.endereco_correios.localidade; 
                    this.formulario.uf =  this.endereco_correios.uf;   
                })
                .catch(error => { 
                    console.log('');
                }) 
            } 
        }
 
    }
